import { z } from "zod";

/**
 * Wire envelope for callables that return a `{ users: … }` list
 * (discovery, Liked You, batch public profiles, and future peers).
 * Row validation happens in app code after this parse.
 */
export const UsersListEnvelopeSchema = z.object({
  users: z.array(z.unknown()),
});

export type UsersListEnvelope = z.infer<typeof UsersListEnvelopeSchema>;
